import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';

import {Alert, AlertType} from '../models/alert';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private subject = new Subject<Alert>();
  private keepAfterRouteChange = false;

  constructor(private router: Router) {
    // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          // only keep for a single route change
          this.keepAfterRouteChange = false;
        } else {
          // clear alert messages
          this.clear();
        }
      }
    });
  }

  getAlert(): Observable<any> {
    return this.subject.asObservable();
  }

  success(message: string, keepAfterRouteChange = false) {
    this.alert(AlertType.Success, message, keepAfterRouteChange);
  }

  error(error, message, keepAfterRouteChange = false) {
    let msg;
    switch (error.status) {
      case 400:
        if (message !== '') {
          msg = message;
        } else {
          msg = 'Error: invalid request.';
        }
        break;
      case 401:
        msg = 'Access denied: Please login and try again.';
        break;
      case 403:
        msg = 'Access denied: You have no permission to ' +
          'access the requested resource. Please consult admin ' +
          'for more info';
        break;
      case 412:
        msg = error.error.message || 'Error: Precondition Failed';
        break;
      case 404:
        msg = 'Error: The requested resource could not be found.';
        break;
      case 500:
        msg = 'Server error: Please try again later';
        break;
      default:
        msg = message;
    }

    this.alert(AlertType.Error, msg, keepAfterRouteChange);
  }

  info(message: string, keepAfterRouteChange = false) {
    this.alert(AlertType.Info, message, keepAfterRouteChange);
  }

  warn(message: string, keepAfterRouteChange = false) {
    this.alert(AlertType.Warning, message, keepAfterRouteChange);
  }

  alert(type: AlertType, message: string, keepAfterRouteChange = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.subject.next(<Alert>{type: type, message: message});
  }

  clear() {
    // clear alerts
    this.subject.next();
  }

}
